"use strict";

// References
var alt = require("../alt");
var ReportsActions = require("../actions/ReportsActions");
var networking = require("../utils/Networking.js");
var Networking = new networking();
var _ = require('underscore');
var reportsStore = alt.createStore(class ReportsStore {
    // Data
    constructor() {
        this.bindActions(ReportsActions);
        this.reportList = [];
        this.items = [];
        this.fetchingItems = true;
    }

    // Functions
    onFetchAllReports() {
        var success = function(result) {
            var newState = {};
            newState.reportList = result;
            this.setState(newState);
        }.bind(this);
        var failure = function(error) {
            var newState = {};
            newState.notification = {
                "type": "error",
                "message": "Tókst ekki að sækja skýrslur",
                "className": "bg-danger",
                "isActive": true,
                "dismissAfter": 4000
            };
            this.setState(newState);
        }.bind(this);

        Networking.GET("statistics/", success, failure);
    }

    onGetItems() {
        var success = function(result) {
            var newState = {};
            newState.items = result;
            newState.fetchingItems = false;
            this.setState(newState);
        }.bind(this);
        var failure = function(error) {
            var newState = {};
            newState.notification = {
                "type": "error",
                "message": "Tókst ekki að sækja skýrslur",
                "className": "bg-danger",
                "isActive": true,
                "dismissAfter": 14000
            };
            newState.fetchingItems = false;
            this.setState(newState);
        }.bind(this);

        Networking.GET("items/", success, failure);
    }
});

module.exports = reportsStore;



// WEBPACK FOOTER //
// ./app/scripts/stores/ReportsStore.js